import { STEP_PATHS } from './step-constants';

export const getFlowCampaignCreation = () =>
  // return windows store by default
  [
    STEP_PATHS.ASSET_GROUP,
    STEP_PATHS.CAMPAIGN_TARGETING,
    STEP_PATHS.CAMPAIGN_SETTING,
  ];

export const getFlowCampaignEdit = () =>
  // return windows store by default
  [
    STEP_PATHS.CAMPAIGN_TARGETING,
    STEP_PATHS.CAMPAIGN_SETTING,
  ];


export const getFlowAssetGroupCreation = () =>
  // return windows store by default
  [
    STEP_PATHS.ASSET_GROUP,
  ];
